/*
 * Устройства звонка. Браузер сам выбирает микрофон и камеру, и если выбрал
 * не то, человеку нужно место, где это поправить. Выбор запоминается на
 * устройстве и применяется при следующем звонке; если устройство пропало,
 * браузер вернётся к умолчанию сам (deviceId — ideal, а не exact).
 *
 * Динамик переключается только там, где есть setSinkId (Chrome, Edge);
 * в Safari списка динамиков нет.
 */

export type InputKind = 'audioinput' | 'videoinput';
export type Facing = 'user' | 'environment';

const KEYS: Record<InputKind, string> = { audioinput: 'code-call-mic', videoinput: 'code-call-cam' };

/** Класс на элементах, играющих звук собеседника: им переключается динамик. */
export const REMOTE_MEDIA_CLASS = 'call-remote-media';

export async function listDevices(): Promise<{
  mics: MediaDeviceInfo[];
  cams: MediaDeviceInfo[];
  speakers: MediaDeviceInfo[];
}> {
  const all = await navigator.mediaDevices.enumerateDevices();
  return {
    mics: all.filter((d) => d.kind === 'audioinput'),
    cams: all.filter((d) => d.kind === 'videoinput'),
    speakers: canPickSpeaker() ? all.filter((d) => d.kind === 'audiooutput') : [],
  };
}

export function canPickSpeaker(): boolean {
  return typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype;
}

export function savedDevice(kind: InputKind): string | null {
  try {
    return localStorage.getItem(KEYS[kind]);
  } catch {
    return null;
  }
}

export function saveDevice(kind: InputKind, id: string): void {
  try {
    localStorage.setItem(KEYS[kind], id);
  } catch {
    /* без памяти — выбор проживёт до конца звонка */
  }
}

export function applySpeaker(deviceId: string): void {
  if (!canPickSpeaker()) return;
  document.querySelectorAll<HTMLMediaElement>(`.${REMOTE_MEDIA_CLASS}`).forEach((el) => {
    void (el as HTMLMediaElement & { setSinkId(id: string): Promise<void> })
      .setSinkId(deviceId)
      .catch(() => {});
  });
}
